const stats = [
  { value: 'RA', label: 'Rechtsanwalt', sub: 'Zugelassen' },
  { value: '2', label: 'DAV-Arbeitsgemeinschaften', sub: 'Sportrecht & Medizinrecht' },
  { value: 'Dr.', label: 'Akademischer Titel', sub: 'Doktor der Rechte' },
  { value: 'ref.', label: 'Sonstige Berufe', sub: 'Referendar' },
];

export default function AboutSection() {
  return (
    <section id="ueber-mich" className="py-28 bg-[#F5F1E8]">
      <div className="max-w-7xl mx-auto px-8">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          <div>
            <div className="flex items-center gap-3 mb-6">
              <span className="w-8 h-px bg-[#1A3A52]" />
              <span className="text-[#1A3A52] text-sm font-medium tracking-widest uppercase">
                Ihr Anwalt in Rostock
              </span>
            </div>

            <h2 className="text-4xl lg:text-5xl font-bold text-[#1A3A52] leading-tight mb-6">
              Kompetenz, die Sie{' '}
              <span className="italic font-light text-amber-600">schützt</span>
            </h2>

            <p className="text-stone-600 text-lg leading-relaxed mb-6">
              Als <strong>Rechtsanwalt</strong> mit den Schwerpunkten <strong>Sportrecht</strong> und{' '}
              <strong>Medizinrecht</strong> vertrete ich Mandanten in komplexen rechtlichen
              Angelegenheiten. Meine Mitgliedschaft in den DAV-Arbeitsgemeinschaften für Sportrecht
              und Medizinrecht unterstreicht meine spezialisierte Expertise.
            </p>

            <p className="text-stone-600 text-lg leading-relaxed mb-8">
              Von Arzthaftungsfragen über Sportvertragsrecht bis hin zu medizinrechtlichen
              Auseinandersetzungen – ich stehe Ihnen mit fundierter Beratung und engagierter
              Vertretung zur Seite. Meine Kanzlei befindet sich zentral in der{' '}
              <strong>Kröpeliner Str. 54, 18055 Rostock</strong>.
            </p>

            {/* Exakte Daten aus anwaltauskunft.de */}
            <div className="bg-white rounded-2xl p-6 mb-6 border border-stone-100">
              <p className="text-xs font-semibold text-stone-400 uppercase tracking-widest mb-4">
                Profildaten (Quelle: Deutsche Anwaltauskunft)
              </p>
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <p className="text-xs text-stone-400 mb-1">Name</p>
                  <p className="text-sm font-semibold text-[#1A3A52]">Dr. Dan Oliver Höftmann</p>
                </div>
                <div>
                  <p className="text-xs text-stone-400 mb-1">Berufsbezeichnung</p>
                  <p className="text-sm font-semibold text-[#1A3A52]">Rechtsanwalt</p>
                </div>
                <div>
                  <p className="text-xs text-stone-400 mb-1">Kanzleianschrift</p>
                  <p className="text-sm font-semibold text-[#1A3A52]">Kröpeliner Str. 54<br />18055 Rostock</p>
                </div>
                <div>
                  <p className="text-xs text-stone-400 mb-1">Telefon</p>
                  <a href="tel:+491772506951" className="text-sm font-semibold text-amber-600 hover:text-amber-700">
                    +49 (177) 250 69 51
                  </a>
                </div>
                <div>
                  <p className="text-xs text-stone-400 mb-1">DAV-Arbeitsgemeinschaft</p>
                  <p className="text-sm font-semibold text-[#1A3A52]">Sportrecht · Medizinrecht</p>
                </div>
                <div>
                  <p className="text-xs text-stone-400 mb-1">Sonstige Berufe</p>
                  <p className="text-sm font-semibold text-[#1A3A52]">Referendar</p>
                </div>
              </div>
            </div>

            <div className="flex flex-wrap gap-3">
              {[
                { label: 'Rechtsanwalt', icon: 'ri-scales-line' },
                { label: 'DAV-AG Sportrecht', icon: 'ri-trophy-line' },
                { label: 'DAV-AG Medizinrecht', icon: 'ri-heart-pulse-line' },
                { label: 'Referendar', icon: 'ri-graduation-cap-line' },
              ].map((badge) => (
                <span
                  key={badge.label}
                  className="flex items-center gap-2 px-4 py-2 bg-[#1A3A52]/10 text-[#1A3A52] text-sm font-medium rounded-full"
                >
                  <i className={badge.icon} />
                  {badge.label}
                </span>
              ))}
            </div>
          </div>

          <div>
            <div className="relative">
              <img
                src="https://storage.readdy-site.link/project_files/eb162f7d-8eeb-4424-a75f-5faf17ec7131/91c65225-9ba1-446f-bbf8-0ea76420307e_2ba81994277fefc97d21286effd31e04.png?v=77d516a8f2f3837ed25ffe904a1d6706"
                alt="Dr. Dan Oliver Höftmann – Rechtsanwalt"
                className="w-full h-[520px] object-cover object-center rounded-2xl"
              />
              <div className="absolute -bottom-6 -left-6 bg-[#1A3A52] text-white rounded-2xl px-6 py-5">
                <p className="text-amber-400 text-xs uppercase tracking-widest mb-1">Kanzlei</p>
                <p className="font-bold">Kröpeliner Str. 54</p>
                <p className="text-white/70 text-sm">18055 Rostock</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
